/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgIdcsGroupAvatar = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm18 0H4v16h16zm-8 3a.714.714 0 1 0 0 1.429A.714.714 0 0 0 12 7zm-2.702.456a2.715 2.715 0 0 1 5.404 0 5.308 5.308 0 0 1 1.842 1.842 2.715 2.715 0 0 1 0 5.404 5.31 5.31 0 0 1-1.842 1.842 2.715 2.715 0 0 1-5.404 0 5.308 5.308 0 0 1-1.842-1.842 2.715 2.715 0 0 1 0-5.404 5.308 5.308 0 0 1 1.842-1.842zm.621 2.001a3.312 3.312 0 0 0-.462.462c.594.498.972 1.245.972 2.081s-.378 1.583-.972 2.08c.138.17.293.325.462.463.498-.594 1.245-.972 2.081-.972s1.583.378 2.081.972c.169-.139.324-.293.462-.462-.594-.498-.972-1.245-.972-2.081s.378-1.583.972-2.081a3.31 3.31 0 0 0-.462-.462c-.498.594-1.245.972-2.081.972s-1.583-.378-2.081-.972zm-2.205 1.829a.714.714 0 1 0 0 1.428.714.714 0 0 0 0-1.428zm8.572 0a.714.714 0 1 0 0 1.428.714.714 0 0 0 0-1.428zM12 15.57A.714.714 0 1 0 12 17a.714.714 0 0 0 0-1.429z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgIdcsGroupAvatar as IdcsGroupAvatar };
